export default __webpack_public_path__ + "static/media/pictogramDonations64.c0e13537.svg";